'use client';

import { FC } from 'react';
import MainBodyToReact from '@/features/contentful/components/MainBodyToReact';
import { TypeHeroComponentWithoutUnresolvableLinksResponse } from '@/features/contentful/_generated';
import CustomImage from '../CustomImage/CustomImage';

type THeroBannerProps = {
    title: string;
    subtitle?: TypeHeroComponentWithoutUnresolvableLinksResponse['fields']['heroImageRichSubTitle'];
    image?: string;
    imageAlt?: string;
    inspectorProps?: any;
};

const HeroBanner: FC<THeroBannerProps> = ({
    inspectorProps = () => ({}),
    title,
    subtitle,
    image,
    imageAlt,
}) => {
    return (
        <div className="tw-relative tw-w-full tw-min-h-[430px] md:tw-min-h-[460px]  tw-rounded-lg tw-overflow-hidden">
            {image && (
                <CustomImage
                    src={image}
                    alt={imageAlt ?? title}
                    priority
                    fill
                    className="tw-object-cover tw-z-0"
                    loading="eager"
                />
            )}
            <div className="tw-absolute tw-inset-0 tw-flex tw-justify-start tw-items-center tw-px-[12px] md:tw-px-[60px]">
                <div className="tw-flex tw-flex-col tw-items-start tw-w-full md:tw-w-[53%] ">
                    {subtitle ? (
                        <h2
                            className="tw-text-white tw-font-gotham-bold tw-font-light tw-uppercase tw-text-[15px] tw-pb-[8px]"
                            {...inspectorProps({
                                fieldId: 'heroImageRichSubTitle',
                            })}
                        >
                            <MainBodyToReact body={subtitle} classes={{ p: '!tw-pb-0' }} />
                        </h2>
                    ) : null}
                    <h1
                        className="tw-text-white tw-font-gotham-bold tw-font-light tw-text-[34px] md:tw-text-[38px] lg:tw-text-[44px] loading-10"
                        {...inspectorProps({
                            fieldId: 'heroImageTitle',
                        })}
                    >
                        {title}
                    </h1>
                </div>
            </div>
        </div>
    );
};

export default HeroBanner;
